<mat-slide-toggle [ngModel]="checked"
                  (ngModelChange)="onchange($event)"
                  [disabled]="disabled"
                  [labelPosition]="labelPosition"
                  [checked]="checked">
  <ng-content />
</mat-slide-toggle>
